import { render, staticRenderFns } from "./peopleDistributed.vue?vue&type=template&id=b3a59440&scoped=true"
import script from "./peopleDistributed.vue?vue&type=script&lang=js"
export * from "./peopleDistributed.vue?vue&type=script&lang=js"
import style0 from "./peopleDistributed.vue?vue&type=style&index=0&id=b3a59440&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a59440",
  null
  
)

export default component.exports